import React from "react";
import { connect } from "react-redux";
import { getters } from "../model";
import { Div, Text3, InfoIcon } from "components/Base";

const decorate = connect(state => ({
  meta: getters.portalMeta(state)
}));

const DebugBar = ({ meta }) => {
  return (
    <Div
      display="row.flex-start.center"
      mb={5}
      width={1}
      bg={"info1"}
      p={3}
      style={{ borderRadius: "5px" }}
    >
      <InfoIcon
        fs={4}
        color="gray7"
        style={{
          borderRadius: "5px",
          marginLeft: "12px",
          marginRight: "12px",
          width: "24px",
          height: "24px"
        }}
      />
      <Text3 className="lennd-wysiwyg-content" fw={2}>
        <ul>
          <li>User ID: {meta.user_id}</li>
          <li>Contact ID: {meta.contact_id}</li>
          <li>Group ID: {meta.account_id}</li>
          <li>Custom Portal ID: {meta.config_set_id}</li>
          <li>Custom Portal Name: {meta.config_set_name}</li>
        </ul>
      </Text3>
    </Div>
  );
};

export default decorate(DebugBar);
